import {Component, Input} from '@angular/core';
import {PublisherStatus, PublisherStatusLabels} from '../../domain/publisher-status.enum';

@Component({
  selector: 'cm-publisher-status-circle',
  template: `
    <span class="status-circle"
          [matTooltip]="showTooltip ? PublisherStatusLabels[status] : ''"
          [ngClass]="{
        'status-circle--orange': status === PublisherStatus.PENDING,
        'status-circle--green': status === PublisherStatus.APPROVED,
        'status-circle--red': status === PublisherStatus.REJECTED,
        'status-circle--gray': !status || status === PublisherStatus.ARCHIVED}">
      <i class="fas fa-circle"></i>
  </span>`
})
export class PublisherStatusCircleComponent {

  @Input()
  public status: PublisherStatus;

  @Input()
  showTooltip = true;

  public PublisherStatus = PublisherStatus;
  public PublisherStatusLabels = PublisherStatusLabels;

}
